export default __webpack_public_path__ + "static/04-37ab91fac15ecd7b5673441287bff724.gif";